export default "__VITE_ASSET__Qt1zqqJb__"